import { atom } from 'jotai';

export const currentOpenSpotlightIndexAtom = atom(-1);
